<template>
  <div
    id="global_session_expiry_modal"
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="global_session_expiry_modal_label"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <p
            id="global_session_expiry_modal_label"
            class="modal-title text-white text-xs mb-0"
          >
            {{ title }}
          </p>
        </div>
        <div class="modal-body">
          <p class="text-dark text-xs mb-0">
            Your session has expired. Would you like to stay logged in or log out?
          </p>
          <p
            class="text-danger text-xs fw-bold mt-3 mb-0"
            :class="{ 'd-none': !error_message }"
            data-session-error
          >
            {{ error_message }}
          </p>
        </div>
        <div class="modal-footer border-0 p-2 d-flex flex-column flex-sm-row justify-content-end gap-2">
          <button
            type="button"
            class="btn btn-light border btn-sm rounded-small text-xs"
            @click="handle_logout"
          >
            Log Out
          </button>
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xs shadow text-dark"
            @click="handle_stay"
          >
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  register_session_modal,
  unregister_session_modal,
} from '@/utils/auth/session_modal';

export default {
  name: 'SessionExpiryModal',
  data: () => ({
    title: 'Session Expired',
    error_message: '',
    resolve_choice: null,
    modal_controller: null,
  }),
  mounted() {
    this.modal_controller = {
      open: this.open,
      close: this.close,
      show_error: this.show_error,
    };
    register_session_modal(this.modal_controller);
  },
  beforeUnmount() {
    unregister_session_modal(this.modal_controller);
  },
  methods: {
    modal_instance() {
      const modal_element = this.$refs.modal;

      if (!modal_element || !window.bootstrap?.Modal) {
        return null;
      }

      return window.bootstrap.Modal.getInstance(modal_element)
        || new window.bootstrap.Modal(modal_element, {
          backdrop: 'static',
          keyboard: false,
        });
    },
    open({ title = 'Session Expired' } = {}) {
      const modal = this.modal_instance();

      if (!modal) {
        return Promise.resolve('logout');
      }

      this.title = title;
      this.error_message = '';

      return new Promise((resolve) => {
        this.resolve_choice = resolve;
        modal.show();
      });
    },
    close() {
      this.modal_instance()?.hide();
    },
    show_error(message) {
      this.error_message = message;
    },
    resolve_and_close(choice) {
      if (this.resolve_choice) {
        this.resolve_choice(choice);
        this.resolve_choice = null;
      }

      this.close();
    },
    handle_logout() {
      this.resolve_and_close('logout');
    },
    handle_stay() {
      this.resolve_and_close('stay');
    },
  },
};
</script>
